<template lang="pug">
  .battery(:title="Math.round(batteryLevel) + '%'")
    span {{Math.round(batteryLevel) + '%'}}
    //- span {{batteryLevel + '%'}}
    .battery-body
      .battery-level(:style="{ width: batteryLevel + '%', backgroundColor: batteryColor }")
        //- span.battery-text {{ Math.round(batteryLevel) + '%' }}
    .battery-tip
</template>

<script>
export default {
  name: "BatteryIcon",
  props: {
    battery: {
      type: Number,
      default: 50
    }
  },

  data() {
    return {
      maxBatt: 4200,
      minBatt: 3500
    }
  },

  computed: {
    batteryColor() {
      // if (this.batteryLevel < 20) return 'red'
      // if (this.batteryLevel < 50) return 'orange'
      // return 'green'

      return 'black'
    },

    batteryLevel(){
      if (this.battery >= this.maxBatt)
        return 100;
      if (this.battery <= this.minBatt)
        return 0;

      return (((this.battery - this.minBatt) * 100) / (this.maxBatt - this.minBatt));
      }
  }
}
</script>

<style scoped>
.battery {
  display: flex;
  align-items: center;
  font-size: 12px; /* Make percentage text smaller */
  gap: 5px; /* Add a small gap between text and battery */
}

.battery-body {
  width: 28px; /* reduced from 40px */
  height: 10px; /* reduced from 16px */
  border: 1px solid #333;
  position: relative;
  background-color: #eee;
  border-radius: 2px;
  overflow: hidden;
}

.battery-level {
  height: 100%;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 8px; /* smaller text if shown inside battery */
  font-weight: bold;
  overflow: hidden;
}

.battery-tip {
  width: 2px; /* smaller tip */
  height: 5px; /* smaller tip */
  background-color: #333;
  margin-left: -2px;
  border-radius: 1px;
}
</style>